import { useEffect, useState } from "react";

//import material
import {
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Card,
  Paper,
  CardHeader,
  Typography,
  CardContent,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Divider,
  Stack,
  Box,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import config from "../../../../config";

//project components
import EmployerSpecializationForm from "./EmployerSpecializationForm";
import useAxiosAuth from "../../../../hooks/useAxiosAuth";
import SpecializationForm from "../../master/employer-specialization/specialization/SpecializationForm";

const EmployerSpecialization = (props) => {
  //Constants
  const axiosAuth = useAxiosAuth();
  const { employerId } = props;
  //States
  const [openAdd, setOpenAdd] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [employerSpecialization, setEmployerSpecialization] = useState();
  const [openSpecializationForm, setOpenSpecializationForm] = useState(false);
  const [selectedSpecialization, setSelectedSpecialization] = useState({
    id: 0,
    name: "",
  });

  const [selectedEmployerSpecialization, setSelectedEmployerSpecialization] =
    useState({
      id: 0,
      employerId: employerId,
      employerSpecializationMasterId: 0,
      employerSubSpecializationMasterId: 0,
      specializationName: "",
      subSpecializationName: "",
    });

  const handleAddSpecialization = () => {
    setSelectedSpecialization({
      id: 0,
      name: "",
    });
    setOpenSpecializationForm(true);
  };
  const handleAdd = () => {
    setSelectedEmployerSpecialization({
      id: 0,
      employerId: employerId,
      employerSpecializationMasterId: 0,
      employerSubSpecializationMasterId: 0,
      specializationName: "",
      subSpecializationName: "",
    });
    setOpenAdd(true);
  };
  const getEmployerSpecializations = () => {
    axiosAuth
      .get("/api/EmployerSpecializations/by-employer?employerId=" + employerId)
      .then((response) => {
        setEmployerSpecialization(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleDelete = () => {
    axiosAuth
      .delete(
        "/api/EmployerSpecializations/" + selectedEmployerSpecialization.id
      )
      .then((response) => {
        getEmployerSpecializations();
        setOpenDelete(false);
      })
      .catch((error) => {
        console.log(error);
        setOpenDelete(false);
      });
  };
  const handleSave = () => {
    //onSave();
    getEmployerSpecializations();
    setOpenAdd(false);
    setOpenSpecializationForm(false);
  };
  const handleCancel = () => {
    setOpenAdd(false);
    setOpenSpecializationForm(false);
  };
  const handleCancelDelete = () => {
    setOpenDelete(false);
  };
  useEffect(() => {
    getEmployerSpecializations();
  }, [employerId]);

  return (
    <Card elevation={3}>
      <Grid
        sx={{
          background: "linear-gradient(to right,#4a7dcf 0%, #2a569f 100%)",
          paddingX: 2,
          paddingY: 0.5,
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <Typography
              variant="h6"
              sx={{
                color: "#ffffff",
              }}
            >
              Employer Specializations
            </Typography>
          </Grid>
          <Grid item>
            <IconButton onClick={handleAdd} title="Add Employer Specialization">
              <AddIcon sx={{ color: "#ffffff" }} />
            </IconButton>
            {/* </Grid>
          <Grid item> */}
            <IconButton
              onClick={handleAddSpecialization}
              title="Add Specialization"
            >
              <AccountBoxIcon sx={{ color: "#ffffff" }} />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Box
          sx={{
            display: { xs: "flex", md: "none" },
            flexDirection: "column",
          }}
        >
          {employerSpecialization && employerSpecialization?.length > 0 ? (
            employerSpecialization?.map((specialization, index) => {
              return (
                <Card
                  key={index}
                  variant="outlined"
                  sx={{
                    margin: 1,
                    paddingX: 1,
                    paddingY: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    backgroundColor: "#F5F5F5",
                  }}
                >
                  <Stack spacing={1}>
                    {/* <Typography>
                    <b>Employer Name:</b> {specialization.employerName}
                  </Typography> */}

                    <Typography>
                      <b>Specialization:</b> {specialization.specializationName}
                    </Typography>
                    <Typography>
                      <b> Sub Specialization/Products:</b>{" "}
                      {specialization.subSpecializationName}
                    </Typography>
                  </Stack>
                  <Stack
                    alignItems="center"
                    justifyContent="center"
                    spacing={2}
                  >
                    <IconButton
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        setSelectedEmployerSpecialization(specialization);
                        setOpenAdd(true);
                      }}
                    >
                      <EditIcon fontSize="inherit" />
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={() => {
                        setSelectedEmployerSpecialization(specialization);
                        setOpenDelete(true);
                      }}
                    >
                      <DeleteIcon fontSize="inherit" />
                    </IconButton>
                    <Typography>{index + 1}</Typography>
                  </Stack>
                </Card>
              );
            })
          ) : (
            <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
              <Typography variant="body1" color="text.secondary">
                No specialization available
              </Typography>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
          }}
        >
          {" "}
          {employerSpecialization && employerSpecialization?.length > 0 ? (
            <TableContainer>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: 40 }}>Sr.No.</TableCell>
                    <TableCell align="left" sx={{ width: 180 }}>
                      Specialization
                    </TableCell>
                    <TableCell align="left">
                      Sub Specialization/Products
                    </TableCell>
                    <TableCell align="right" sx={{ width: 90 }}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {employerSpecialization?.map((row, index) => (
                    <TableRow key={row.id}>
                      <TableCell component="th" scope="row">
                        {index + 1}
                      </TableCell>
                      <TableCell align="left">
                        {row.specializationName}
                      </TableCell>
                      <TableCell align="left">
                        {row.subSpecializationName}
                      </TableCell>
                      <TableCell align="right">
                        <IconButton
                          variant="outlined"
                          color="primary"
                          size="small"
                          onClick={() => {
                            setSelectedEmployerSpecialization(row);
                            setOpenAdd(true);
                          }}
                        >
                          <EditIcon fontSize="inherit" />
                        </IconButton>
                        <IconButton
                          color="error"
                          size="small"
                          onClick={() => {
                            setSelectedEmployerSpecialization(row);
                            setOpenDelete(true);
                          }}
                        >
                          <DeleteIcon fontSize="inherit" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
              <Typography variant="body1" color="text.secondary">
                No specialization available
              </Typography>
            </Box>
          )}
        </Box>
      </Grid>

      <Dialog open={openAdd} onClose={handleCancel} fullWidth>
        <DialogContent>
          <EmployerSpecializationForm
            onSave={handleSave}
            onCancel={handleCancel}
            selectedEmployerSpecialization={selectedEmployerSpecialization}
          />
        </DialogContent>
      </Dialog>
      <Dialog open={openSpecializationForm} onClose={handleCancel} fullWidth>
        <DialogContent>
          <SpecializationForm
            onSave={handleSave}
            onCancel={handleCancel}
            selectedEmployerSpecialization={selectedSpecialization}
          />
        </DialogContent>
      </Dialog>

      <Dialog open={openDelete} onClose={handleCancelDelete} fullWidth>
        <DialogTitle>Delete Specialization</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the specialization{" "}
            <span style={{ color: "#E90000" }}>
              {selectedEmployerSpecialization?.specializationName}
            </span>
            ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDelete} variant="contained">
            Yes
          </Button>
          <Button onClick={handleCancelDelete} variant="outlined">
            No
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default EmployerSpecialization;
